module.exports = __webpack_public_path__ + "static/media/QualityIcon.757af9f1.svg";